import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MtnaPopoverModule, MtnaSearchBoxModule, MtnaSelectSearchModule } from '@mtna/lib-ui';

import { RdsChipsModule } from '../chips/index';
import { RdsFilterSummaryChipsPipeModule, RdsVariableFilterTypePipeModule } from '../core/pipes/index';
import { RdsDateFilterModule } from '../date-filter/index';
import { RdsNumericFilterModule } from '../numeric-filter/index';
import { RdsTextFilterModule } from '../text-filter/index';
import { RdsFilterDialogComponent } from './filter-dialog.component';
import { RdsFilterSelectComponent } from './filter-select.component';
import { FilterTypeSubtitlePipe } from './filter-type-subtitle.pipe';
import { RdsFilterComponent } from './filter.component';
import { RdsGetFilterValuePipe } from './get-select-value.pipe';
import { RdsNullFilterModule } from '../null-filter/index';
import { MatDividerModule } from '@angular/material/divider';

const COMPONENTS = [RdsFilterComponent, RdsFilterDialogComponent, RdsFilterSelectComponent];
const PIPES = [RdsGetFilterValuePipe, FilterTypeSubtitlePipe];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatTooltipModule,
    MtnaPopoverModule,
    MtnaSearchBoxModule,
    MtnaSelectSearchModule,
    RdsChipsModule,
    RdsDateFilterModule,
    RdsFilterSummaryChipsPipeModule,
    RdsNullFilterModule,
    RdsNumericFilterModule,
    RdsTextFilterModule,
    RdsVariableFilterTypePipeModule,
    ScrollingModule,
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS, PIPES],
  entryComponents: [RdsFilterDialogComponent],
})
export class RdsFilterModule {}

export * from './filter.component';
export * from './filter-select.component';
export * from './filter-dialog.component';
